/**
 * Turkish UI: Pertev. English UI: Giles.
 */
export function getAssistantDisplayName(locale: string | undefined): string {
  const l = (locale || '').toLowerCase();
  return l.startsWith('tr') ? 'Pertev' : 'Giles';
}
